import { useForgotPasswordMutation } from '@api/api';
import { ForgotPasswordRequest } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  AuthBlockContainer,
  AuthSuccessMessage,
  Button,
  ResponseError,
  ResponseErrorList,
  RteBlock,
} from '@components';
import { Stack, TextField, Typography } from '@mui/material';
import { t } from '@translations';
import { useForm } from 'react-hook-form';

/**
 * Properties type for the Forgotten Password Block
 */
export type ForgottenPasswordBlockProps = {
  title?: string;
  text?: string;
  emailLabel?: string;
  submitLabel?: string;
  successMessage?: string;
};

/**
 * Reset Password Block component
 */
export const ForgottenPasswordBlock = (props: ForgottenPasswordBlockProps) => {
  const { title, text, emailLabel, submitLabel, successMessage } = props;
  const [trigger, request] = useForgotPasswordMutation();
  const {
    register,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm();
  const errors = (request.error as any)?.data?.errors;

  const onSubmit = (formData: ForgotPasswordRequest) => {
    trigger({ ...formData });
  };

  const form = (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2}>
        <Typography>{title}</Typography>
        <RteBlock text={text} />
        <TextField
          {...register('Email', {
            required: true,
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          })}
          name='Email'
          label={emailLabel}
          fullWidth
          error={!!formErrors.Email}
          helperText={
            !!formErrors.Email ? t(TextCodes.Base.GenericError.InvalidEmailAddress) : undefined
          }
        />
        <ResponseError fieldName='Email' errors={errors} />
        <ResponseErrorList errors={errors} excludeKeys={['Email']} />
        <Button variant='primary' type='submit' busy={request.isLoading}>
          {submitLabel}
        </Button>
      </Stack>
    </form>
  );

  return (
    <AuthBlockContainer>
      {request.isSuccess && <AuthSuccessMessage message={successMessage} />}
      {!request.isSuccess && form}
    </AuthBlockContainer>
  );
};
